import { Column } from '@ant-design/plots';
import { Card } from 'antd';
import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import ReportService from "../../../redux/services/reports";

const OverdueTaskByWeek = (props) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const payload = {
            'filters': props.filters
        };
        ReportService.overdueTaskByWeek(payload).then(res => {
            setData(res);
        });
    }, [props.filters])

    const config = {
        data,
        isGroup: true,
        xField: 'label',
        yField: 'count'
    };


    return (
        <Card title="Overdue Task By Week">
            <Column {...config} />
        </Card>
    );
}


function mapStateToProps(state) {
    return {}
}

export default connect(mapStateToProps)(OverdueTaskByWeek);

